import React, { useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import { toast } from "react-toastify";

import { postRequest } from 'utils/request';
import { i18n } from '../../../translate/i18n';


function ForgotPassword({ setForgotPassword }) {
  const [loading, setLoading] = useState(false);
  const [login, setLogin] = useState('');

  const handleConfirm = async (event) => {
    event.preventDefault();
    if(login) {
      setLoading(true);
      await postRequest(`/authentications/admin/forgotpassword`, {
        login
      }).then(() => {
        setForgotPassword(false);
        setLoading(false);
      })
    } else {
      toast.info(i18n.t('informALogin'))
    }
    setLoading(false);
  };

  return (
    <div className="bg-login-page">
      <div className="container-login">
        <div className="login-content first-content ">
          <div className="first-column-login">
          <h2 className="title">{i18n.t('welcomeHeader')}</h2>
          <div className="logo">
            <img
            className="img-logo"
            src="assets/images/logo-omni.png"
            alt="logo"
            />
          </div>
          </div>

          <div className="second-column-login">
          <h1 className="title-login">{i18n.t('forgotPassword')}</h1>
          <form className="form-login">
            <div className="input-form-login">
              <input
                  type="text"
                  placeholder={i18n.t('user')}
                  required
                  value={login}
                  onChange={(value) => setLogin(value.target.value)}
                  style={{ paddingLeft: 15 }}
              />
            </div>
            <div className="box-btn-login" style={{marginTop: 50}}>
              <>
                {!loading ? (
                <button 
                    type="submit"
                    className="btn-login" 
                    onClick={handleConfirm}
                >
                {i18n.t('send')}
                </button>
                ) : (
                <div className="area-loading-login">
                    <CircularProgress />
                </div>
                )}
              </>
            </div>
            </form>
            <div 
              onClick={() => setForgotPassword(false)} 
              style={{cursor: 'pointer', fontSize:20}}
            >
              {i18n.t('getBack')}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;